import { PayloadAction, createAction, createSlice } from "@reduxjs/toolkit";

const clearAction = createAction("clear");

export interface TodoState {
  includeDoneTodos: boolean;
}

const initialState: TodoState = {
  includeDoneTodos: false,
};

const todoSlice = createSlice({
  name: "todo",
  initialState,
  reducers: {
    setTodoIncludeDoneTodos: (state, action: PayloadAction<boolean>) => {
      state.includeDoneTodos = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(clearAction, () => initialState);
  },
});

export const { setTodoIncludeDoneTodos } = todoSlice.actions;
export default todoSlice.reducer;
